import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'documents-status-filter',
    templateUrl: './documents-status-filter.component.html',
    styleUrls: ['./documents-status-filter.component.scss']
})
export class DocumentsFilterComponent implements OnInit {
    public showDropdown = false;

    @ViewChild('publicCheckbox') publicCheckbox: ElementRef;
    @ViewChild('notPublicCheckbox') notPublicCheckbox: ElementRef;
    @ViewChild('ownerOnSite') ownerOnSite: ElementRef;
    @ViewChild('ownerOffSite') ownerOffSite: ElementRef;
    @ViewChild('tenant') tenant: ElementRef;
    @ViewChild('resident') resident: ElementRef;
    @ViewChild('all') all: ElementRef;
    @ViewChild('ownerAll') ownerAll: ElementRef;
    @ViewChild('residentOwner') residentOwner: ElementRef;
    @ViewChild('residentOnlyNotOnDeed') residentOnlyNotOnDeed: ElementRef;
    @ViewChild('ownerFamily') ownerFamily: ElementRef;
    @ViewChild('guest') guest: ElementRef;
    @ViewChild('offsiteResident') offsiteResident: ElementRef;
    @ViewChild('occupant') occupant: ElementRef;
    @ViewChild('notSet') notSet: ElementRef;

    constructor(private urlService: UrlService) {
    }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const isPublic = this.urlService.queryParams['is_public'];
            if (isPublic) {
                this.publicCheckbox.nativeElement.checked = isPublic.indexOf('1') !== -1;
                this.notPublicCheckbox.nativeElement.checked = isPublic.indexOf('0') !== -1;
            } else {
                this.publicCheckbox.nativeElement.checked = false;
                this.notPublicCheckbox.nativeElement.checked = false;
            }

            const permissions = this.urlService.queryParams['permissions'];
            if (permissions) {
                this.ownerOnSite.nativeElement.checked = permissions.indexOf('owner_on') !== -1;
                this.ownerOffSite.nativeElement.checked = permissions.indexOf('owner_off') !== -1;
                this.tenant.nativeElement.checked = permissions.indexOf('rent') !== -1;
                this.resident.nativeElement.checked = permissions.indexOf('resident') !== -1;
                this.all.nativeElement.checked = permissions.indexOf('all') !== -1;
                this.ownerAll.nativeElement.checked = permissions.indexOf('owner_all') !== -1;
                this.residentOwner.nativeElement.checked = permissions.indexOf('resident_owner') !== -1;
                this.residentOnlyNotOnDeed.nativeElement.checked = permissions.indexOf('resident_only_not_on_deed') !== -1;
                this.ownerFamily.nativeElement.checked = permissions.indexOf('owner_family') !== -1;
                this.guest.nativeElement.checked = permissions.indexOf('guest') !== -1;
                this.offsiteResident.nativeElement.checked = permissions.indexOf('offsite_resident') !== -1;
                this.occupant.nativeElement.checked = permissions.indexOf('occupant') !== -1;
                this.notSet.nativeElement.checked = permissions.indexOf('not_set') !== -1;
            } else {
                this.ownerOnSite.nativeElement.checked = false;
                this.ownerOffSite.nativeElement.checked = false;
                this.tenant.nativeElement.checked = false;
                this.resident.nativeElement.checked = false;
                this.all.nativeElement.checked = false;
                this.ownerAll.nativeElement.checked = false;
                this.residentOwner.nativeElement.checked = false;
                this.residentOnlyNotOnDeed.nativeElement.checked = false;
                this.ownerFamily.nativeElement.checked = false;
                this.guest.nativeElement.checked = false;
                this.offsiteResident.nativeElement.checked = false;
                this.occupant.nativeElement.checked = false;
                this.notSet.nativeElement.checked = false;
            }
        });
    }

    changeFilter() {
        const publicCheckbox = this.publicCheckbox.nativeElement.checked;
        const notPublicCheckbox = this.notPublicCheckbox.nativeElement.checked;

        if (!publicCheckbox && !notPublicCheckbox) {
            this.urlService.queryParams['is_public'] = null;
        } else {
            let isPublic = '';
            if (publicCheckbox) isPublic += '1,';
            if (notPublicCheckbox) isPublic += '0,';
            this.urlService.queryParams['is_public'] = isPublic.slice(0, -1);
        }

        let permissions: any = {};
        permissions['owner_on'] = this.ownerOnSite.nativeElement.checked;
        permissions['owner_off'] = this.ownerOffSite.nativeElement.checked;
        permissions['owner_all'] = this.ownerAll.nativeElement.checked;
        permissions['rent'] = this.tenant.nativeElement.checked;
        permissions['resident'] = this.resident.nativeElement.checked;
        permissions['all'] = this.all.nativeElement.checked;
        permissions['resident_owner'] = this.residentOwner.nativeElement.checked;
        permissions['resident_only_not_on_deed'] = this.residentOnlyNotOnDeed.nativeElement.checked;
        permissions['owner_family'] = this.ownerFamily.nativeElement.checked;
        permissions['guest'] = this.guest.nativeElement.checked;
        permissions['offsite_resident'] = this.offsiteResident.nativeElement.checked;
        permissions['occupant'] = this.occupant.nativeElement.checked;
        permissions['not_set'] = this.notSet.nativeElement.checked;

        let permissionsQuery: string = '';
        for (const key in permissions) {
            if (permissions[key]) {
                permissionsQuery += key + ',';
            }
        }
        this.urlService.queryParams['permissions'] = permissionsQuery.slice(0, -1);

        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('.documents-status-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-status-filter/documents-status-filter.component.ts